import React, { Component } from 'react';

import { chainesLocales } from './../include/chainesLocales';
import { getJson, getErrMsg } from '../service/serviceUtil';

import ContextualMessage from '../components/contextualMessage';
import UserDisplay from '../components/userDisplay';

class CreerCourriel extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            token: this.props.token,
            courriel: "",
            question: "o",
            error: null,
            txtMsg: null,
            typeMsg: null,
            errorApi: false
        };
    }

    get labels() {
        return chainesLocales['CreerCourriel'][this.props.lang];
    }

    render() {
        let submitDisabled = (!this.isCourrielValid());

        return (
            <form className="text-left" onSubmit={this.onSubmit.bind(this)}>
                <h1>{this.labels.title}</h1>
                <ContextualMessage type="info" showIcon={false} content={this.props.config[`MES_INFO_ADRES_COURL_${this.props.lang}`]} />
                <UserDisplay user={this.props.user.username} lang={this.props.lang} />
                {
                    this.state.error ? <ContextualMessage type="error" content={getErrMsg(this.state.error, this.props.lang)} /> : null
                }
                {
                    this.state.txtMsg ? <ContextualMessage type={this.state.typeMsg} showIcon={false} content={this.state.txtMsg} /> : null
                }
                {
                    this.state.errorApi ? <ContextualMessage type="error" showIcon={false} content={chainesLocales['ErrApi'][this.props.lang].msg} /> : null
                }
                <div className="row">
                    <div className="col">
                        <div className="mb-1"><strong style={{ fontSize: "1.1rem" }}>{this.labels.labelQuestion}</strong></div>
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" type="radio" name="question" id="question_oui" value="o" checked={this.state.question === 'o'} onChange={this.onChangeQuestion.bind(this)} />
                            <label className="form-check-label" htmlFor="question_oui">{this.labels.oui}</label>
                        </div>
                        <div className="form-check form-check-inline mb-3">
                            <input className="form-check-input" type="radio" name="question" id="question_non" value="n" checked={this.state.question === 'n'} onChange={this.onChangeQuestion.bind(this)} />
                            <label className="form-check-label" htmlFor="question_non">{this.labels.non}</label>
                        </div>
                        {this.state.question === 'o' ?
                        <div className="form-group">
                            <label htmlFor="courriel" className={submitDisabled ? 'is-invalid font-weight-bold' : 'font-weight-bold'} style={{ fontSize: "1.1rem" }}>{this.labels.labelCourriel}</label>
                            <input className={`form-control ${submitDisabled ? 'is-invalid' : ''}`} id="courriel" type="text" maxLength={100} size={100} style={{ width: '66%' }} value={this.state.courriel} onChange={this.onChangeCourriel.bind(this)} />
                            <div className="invalid-feedback">{this.labels.erreurCourriel}</div>
                        </div> : null}
                        <div>
                            <button className="btn btn-primary" type="submit" disabled={this.state.question === 'o' && (submitDisabled || this.state.courriel.length === 0)}><span className="label">{this.labels.button}</span><span className="spinner"></span></button>
                        </div>
                    </div>
                </div>
            </form>
        )
    }

    onSubmit(e) {
        e.preventDefault();
        
        if (document.querySelector) {
            document.querySelector('button[type="submit"]').disabled = true;
            if (document.body.classList) document.querySelector('button[type="submit"]').classList.add('loading');
        }

        let formData = new FormData();
            
        formData.append("question", this.state.question);
        formData.append("courriel", this.state.courriel.trim());
        formData.append("token", this.state.token);

        let defaultParams = {
            lang: this.props.lang,
            suffixe: this.props.suffixe
        };

        let fetchOptions = {
            method: "POST",
            credentials: "same-origin",
            body: formData
        };

        getJson('createCourriel', defaultParams, fetchOptions).then(data => {
            if (data === true) {
                this.props.onPageSuccess();
            } else {
                this.setState({ error: data.error, typeMsg: data.type, txtMsg: data.message, errorApi: ((!data.error && !data.message) ? true : false) }, () => {
                    if (document.querySelector) {
                        document.querySelector('button[type="submit"]').disabled = false;
                        if (document.body.classList) document.querySelector('button[type="submit"]').classList.remove('loading');
                    }
                });
            }
        }).catch(err => {
            console.error("Erreur API creer courriel: " + err);
    
            this.setState({ errorApi: true, error: null, typeMsg: null, txtMsg: null }, () => {
                if (document.querySelector) {
                    document.querySelector('button[type="submit"]').disabled = false;
                    if (document.body.classList) document.querySelector('button[type="submit"]').classList.remove('loading');
                }
            });
        });
    }

    onChangeCourriel(e) {
        this.setState({ courriel: e.target.value.trim() });
    }

    onChangeQuestion(e) {
        this.setState({ question: e.target.value, courriel: (e.target.value === 'n' ? '' : this.state.courriel) });
    }

    // Valider le courriel
    isCourrielValid() {
        const re = /(^.+@.+\..+$|^$)/;
        
        return re.test(this.state.courriel);
    }
}

export default CreerCourriel;